module.exports = __webpack_public_path__ + "img/progress_084.00c8ff48.png";